import { useEffect, useState } from "react";
import { History, Loader2, ChevronDown, ChevronUp, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { SectionHead } from "./fields";

const label = (path) => path.replace(/^tiers\./, "Package · ").replace(/^room_types\./, "Room · ").replace(/^addons\./, "Add-on · ")
  .replace(/\.items\.(\d+)\./, " · item $1 · ").replace(/_/g, " ").replace(/\./g, " › ");
const fmtVal = (v) => (v === undefined || v === null ? "—" : typeof v === "boolean" ? (v ? "yes" : "no") : String(v));

export default function HistoryAdmin() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/admin/rate-card/history").then((r) => setRows(r.data)).catch((e) => toast.error(formatErr(e))); }, []);
  if (!rows) return <Loader2 className="w-6 h-6 animate-spin text-brand-accent" />;
  return (
    <div data-testid="admin-history">
      <SectionHead title="Price change history" sub="Every rate card save, newest first. Past quotations are never affected by these changes." />
      {rows.length === 0 && <div className="rounded-2xl border border-dashed border-brand-line p-12 text-center text-sm text-brand-muted" data-testid="admin-history-empty">No changes recorded yet.</div>}
      <div className="space-y-3">
        {rows.map((h, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="rounded-2xl border border-brand-line bg-brand-cream" data-testid={`history-entry-${i}`}>
              <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left" data-testid={`history-toggle-${i}`}>
                <div className="flex items-center gap-3">
                  <span className="w-8 h-8 rounded-full bg-brand-sand grid place-items-center text-brand-accent">{h.action === "reset" ? <RotateCcw className="w-4 h-4" /> : <History className="w-4 h-4" />}</span>
                  <div>
                    <p className="text-sm text-brand-ink">{h.action === "reset" ? "Reset to defaults" : `${h.count} change${h.count === 1 ? "" : "s"}`} <span className="text-brand-muted">by {h.changed_by}</span></p>
                    <p className="text-xs text-brand-muted-light">{new Date(h.changed_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</p>
                  </div>
                </div>
                {isOpen ? <ChevronUp className="w-4 h-4 text-brand-muted" /> : <ChevronDown className="w-4 h-4 text-brand-muted" />}
              </button>
              {isOpen && (
                <div className="border-t border-brand-line px-5 py-3 max-h-80 overflow-y-auto" data-testid={`history-changes-${i}`}>
                  {h.changes.map((c, j) => (
                    <div key={j} className="grid grid-cols-12 gap-3 py-1.5 text-xs border-b border-brand-line/60 last:border-0">
                      <span className="col-span-6 text-brand-ink">{label(c.path)}</span>
                      <span className="col-span-3 font-mono-num text-brand-muted-light line-through truncate">{fmtVal(c.from)}</span>
                      <span className="col-span-3 font-mono-num text-brand-ink truncate">{fmtVal(c.to)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
